/**
*  料金シミュレーター
*
*  入所 & 入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_entrance = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階②　 ]
  income : [ 1730, 300, 390, 650, 1360 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  multi  : {
    four : [ 530, 0, 370, 370, 370 ],
    two  : [ 1630, 1100, 1470, 1470, 1470 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階①, 第3段階② ]
  single : [ 3580, 2140, 2140, 2960, 2960 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1686, 2932, 4178  ],
        two  : [ 1686, 2932, 4178  ]
      },
      single : [ 1600, 2761, 3922 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1765, 3090, 4415 ],
          two  : [ 1765, 3090, 4415 ]
        },
      single : [ 1677, 2915, 4153 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1833, 3227, 4620 ],
          two  : [ 1833, 3227, 4620 ]
        },
      single : [ 1743, 3047, 4351 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1893, 3346, 4799 ],
          two  : [ 1893, 3346, 4799 ]
        },
      single : [ 1803, 3167, 4531 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1952, 3464, 4976 ],
          two  : [ 1952, 3464, 4976 ]
        },
      single : [ 1864, 3289, 4713 ]
    }
  ]
}




/**
*  function
*  動作
*/

// 入所
$( calcBtn.entrance ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.entrance ).serializeArray();
  const selectVal = selectCheck( currentForm.entrance, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_entrance.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_entrance.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_entrance.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }
    // 結果を出して表示する
    const result = ( array_entrance.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * 31;
    $( resultElm.entrance ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});



// 入所（認知棟）
$( calcBtn.entranceSub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.entranceSub ).serializeArray();
  const selectVal = selectCheck( currentForm.entranceSub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_entrance.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_entrance.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_entrance.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_entrance.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * 31;
    $( resultElm.entranceSub ).html( numberWithComma.format( result ) );

  } // end of 計算処理開始

return;

});
